import axios from './axios';
import {getCheckoutTracking, trackMarketingEvent} from '../lib/marketingTracking';

const unwrap = (response) => response?.data?.data ?? response?.data ?? response;

function selectedWorkspace(workspaceId) {
  const value = String(workspaceId || '').trim();
  if (!value) throw new Error('Selecione um espaço de trabalho.');
  return value;
}

export async function createCheckoutSession(workspaceId, priceId) {
  const response = await axios.post('/api/checkout', {
    workspaceId: selectedWorkspace(workspaceId),
    priceId,
    tracking: getCheckoutTracking(),
  });
  const session = unwrap(response);
  if (session?.url || (typeof session === 'string' && session)) trackMarketingEvent('begin_checkout', {items: [{item_id: priceId}]});
  return session;
}

export async function fetchBilling(workspaceId, currency) {
  return unwrap(await axios.get('/api/checkout/billing', {
    params: {workspaceId: selectedWorkspace(workspaceId), ...(currency ? {currency} : {})},
    cache: false,
  }));
}

export async function createBillingPortal(workspaceId) {
  return unwrap(await axios.post('/api/checkout/billing/portal', {
    workspaceId: selectedWorkspace(workspaceId),
  }));
}

export async function purchaseBillingSeats(workspaceId, values) {
  return unwrap(await axios.post('/api/checkout/billing/seats', {
    workspaceId: selectedWorkspace(workspaceId),
    quantity: values.quantity,
    priceId: values.priceId,
  }));
}

export async function changeBillingPlan(workspaceId, priceId) {
  return unwrap(await axios.post('/api/checkout/billing/plan', {
    workspaceId: selectedWorkspace(workspaceId),
    priceId,
  }));
}

export async function acceptBillingRetentionOffer(workspaceId, values) {
  return unwrap(await axios.post('/api/checkout/billing/retention', {
    workspaceId: selectedWorkspace(workspaceId),
    reason: values.reason,
    feedback: values.feedback,
  }));
}

export async function cancelBillingSubscription(workspaceId, values) {
  return unwrap(await axios.post('/api/checkout/billing/cancel', {
    workspaceId: selectedWorkspace(workspaceId),
    reason: values.reason,
    feedback: values.feedback,
  }));
}
